import { render, staticRenderFns } from "./Add_PuYang.vue?vue&type=template&id=7c16f3a2&scoped=true&"
import script from "./Add_PuYang.vue?vue&type=script&lang=js&"
export * from "./Add_PuYang.vue?vue&type=script&lang=js&"
import style0 from "./Add_PuYang.vue?vue&type=style&index=0&id=7c16f3a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c16f3a2",
  null
  
)

export default component.exports